module.exports = __webpack_public_path__ + "static/media/c.f278be79.png";